import $ from 'jquery';

export class SelectBox {

	_selectBoxElCtnEl;
	_selectBoxCtnEl;
	_selectBoxCurrentEl;
	_selectedBoxInputEls;
	_optionEls;

	_salt;

	_selectedElId;
	_selectedInputEl;
	_hiddenInputEl;

	/**
	 * Constructor.
	 *
	 * @return {void}
	 */
	constructor( selectBox ) {

		this.selectBoxElCtnEl = $( selectBox );
		this.salt = this.selectBoxElCtnEl.attr( 'data-salt' );

		if ( this.selectBoxElCtnEl.length && this.salt ) {

			this.selectBoxCurrentEl = this.selectBoxElCtnEl.find( `#select-box-current-${ this.salt }` );
			this.hiddenInputEl = this.selectBoxElCtnEl.find( `#selected-input-val-${ this.salt }` );

			this.selectedBoxInputEls = this.selectBoxElCtnEl.find( '.select-box__input' );
			this.optionEls = this.selectBoxElCtnEl.find( '.select-box__option' );

			this.bindEvents();
		}
	}

	bindEvents() {
		this.selectBoxCurrentEl.on( 'click', ( event ) => this.toggleDropdown( event ) );
		this.optionEls.on( 'click', ( event ) => this.selectOption( event ) );

	}

	/**
	 * Show/hide the dropdown.
	 *
	 * @param e
	 */
	toggleDropdown( e = null ) {
		this.selectBoxCurrentEl.toggleClass( 'is-open' );
	}

	/**
	 * Select option.
	 * @param e
	 */
	selectOption( e = null  ) {
		// Get the id of the selected input element, using for attribute.
		this.selectedElId = $( e.target ).attr( 'for' );
		this.selectedInputEl = $( `#${ this.selectedElId }` );

		this.checkTheSelectedItem();
		this.setSelectedIdToHiddenInputEl();
		this.toggleIsSelectedClass( e.target );

		this.toggleDropdown();

		this.selectBoxElCtnEl.trigger( {
			type: "selectedValue",
			value: this.hiddenInputEl.val(),
			inputData: this.hiddenInputEl.data(),
		} );
	}

	checkTheSelectedItem() {
		// Remove checked attributed from all elements, so that we can add it only to the one that is selected.
		this.selectedBoxInputEls.removeAttr( 'checked' );

		// Add the checked attribute to the element that is selected.
		this.selectedInputEl.attr( 'checked', 'checked' );
	}

	setSelectedIdToHiddenInputEl() {
		// Get the selected term id.
		const selectedTermId = this.selectedInputEl.val();
		const selectedTermData = this.selectedInputEl.data();

		// Set the id of the selected term in the hidden input value.
		this.hiddenInputEl.val( selectedTermId );

		if ( selectedTermData ) {
			for ( const [ key, value ] of Object.entries( selectedTermData ) ) {
				this.hiddenInputEl.data( key, value );

				// this.hiddenInputEl.attr( `data-${key}`, value );
			}
		}
	}

	toggleIsSelectedClass( selectedLabelEl ) {
		// Toggle isSelected Class for selectBox
		this.selectBoxCurrentEl.addClass( 'is-selected' );

		// Remove isSelected class from the all the labels and to the one selected, so that we can add a background color to it.
		this.optionEls.removeClass( 'is-selected' );
		$( selectedLabelEl ).addClass( 'is-selected' );
	}

	set selectBoxElCtnEl( value ) {
		this._selectBoxElCtnEl = value;
	}

	set selectBoxCtnEl( value ) {
		this._selectBoxCtnEl = value;
	}

	set selectBoxCurrentEl( value ) {
		this._selectBoxCurrentEl = value;
	}

	set selectedBoxInputEls( value ) {
		this._selectedBoxInputEls = value;
	}

	set optionEls( value ) {
		this._optionEls = value;
	}

	set selectedElId( value ) {
		this._selectedElId = value;
	}

	set selectedInputEl( value ) {
		this._selectedInputEl = value;
	}

	set hiddenInputEl( value ) {
		this._hiddenInputEl = value;
	}

	set salt( value ) {
		this._salt = value;
	}
	
	
	get selectBoxElCtnEl() {
		return this._selectBoxElCtnEl;
	}

	get selectBoxCtnEl() {
		return this._selectBoxCtnEl;
	}
	
	get selectBoxCurrentEl() {
		return this._selectBoxCurrentEl;
	}

	get selectedBoxInputEls() {
		return this._selectedBoxInputEls;
	}

	get optionEls() {
		return this._optionEls;
	}

	get selectedElId() {
		return this._selectedElId;
	}

	get selectedInputEl() {
		return this._selectedInputEl;
	}

	get hiddenInputEl() {
		return this._hiddenInputEl;
	}

	get salt() {
		return this._salt;
	}

}

